import produce from 'immer';

import {StructuredTable} from 'notebook/structured-tables/StructuredTableConstants';
import TableUtil from 'notebook/tables/TableUtil';

/** Re-merges a Structured Table's single input columns. Call after adding rows to a table.
 *
 * This is very similar to remergeSingleInputColumns in TableUtil except that it operates directly on a
 * StructuredTable rather than a Table.
 */
export default function remergeStructuredTableSingleInputs<TTableMetadata, TRowMetadata>(
  structuredTable: StructuredTable<TTableMetadata, TRowMetadata>
): StructuredTable<TTableMetadata, TRowMetadata> {
  const singleInputIndexRange = TableUtil.getSingleInputIndexRange(structuredTable.columns);
  // if there are no single input columns, return the table as is
  if (!singleInputIndexRange) {
    return structuredTable;
  }
  const [sliceStart, sliceEnd] = singleInputIndexRange;
  return produce(structuredTable, (draft) => {
    const {rows} = draft;
    for (const [rowIndex, row] of rows.entries()) {
      for (let columnIndex = sliceStart; columnIndex <= sliceEnd; columnIndex++) {
        const cell = row.cells[columnIndex];
        // if it's the first row, expand the merge to the full table
        if (rowIndex === 0) {
          cell.mergeRowSpan = rows.length;
          cell.mergeColSpan = 1;
          // for all other rows, clear the cell
        } else {
          row.cells[columnIndex] = TableUtil.makeEmptyCell();
        }
      }
    }
  });
}
